import React, { useState } from "react";
import { FaCheck, FaChevronRight, FaTruckLoading, FaHistory } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const ServiceRequestNew = () => {
    // Ejemplo de datos para que veas cómo luce el diseño
    const [requests, setRequests] = useState([
        { id: "8842", status_id: 25, status: { name: "Assigned" } },
        { id: "8840", status_id: 30, status: { name: "In Transit" } }
    ]);
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-cs-bg-alt pb-safe font-sans">
            {/* STICKY HEADER */}
            <header className="sticky top-0 z-40 bg-white/80 backdrop-blur-md px-4 py-5 border-b border-cs-border">
                <div className="flex items-center justify-between max-w-4xl mx-auto">
                    <h1 className="text-lg font-bold text-cs-dark tracking-tight">Active Dispatches</h1>
                    <div className="w-10 h-10 rounded-full bg-cs-primary-soft flex items-center justify-center text-cs-primary">
                        <FaTruckLoading />
                    </div>
                </div>
            </header>

            <div className="max-w-4xl mx-auto p-4 flex flex-col gap-4">

                {/* LIST SECTION */}
                <section>
                    <div className="flex items-center justify-between mb-4 px-1">
                        <h3 className="text-[11px] font-bold text-cs-muted uppercase tracking-[0.2em]">Live Loads</h3>
                        <span className="text-[10px] font-bold text-cs-primary bg-white px-2 py-1 rounded-lg border border-cs-primary/10 shadow-sm">
                            {requests.length} Available
                        </span>
                    </div>

                    {requests.length > 0 ? (
                        <div className="space-y-3">
                            {requests.map((load) => (
                                <div
                                    key={load.id}
                                    onClick={() => navigate(`/active-load/${load.id}`)}
                                    className="flex items-center bg-white p-4 rounded-[2rem] shadow-soft border border-white active:scale-[0.98] transition-all"
                                >
                                    {/* Icon Container */}
                                    <div className={`relative w-12 h-12 flex items-center justify-center rounded-2xl shrink-0 ${load.status_id < 30 ? 'bg-cs-primary text-white' : 'bg-cs-primary-soft text-cs-primary'
                                        }`}>
                                        <FaTruckLoading size={20} />

                                        {load.status_id === 30 && (
                                            <span className="absolute -bottom-1 -right-1 w-5 h-5 flex items-center justify-center rounded-full bg-cs-success text-white text-[10px] border-2 border-white">
                                                <FaCheck />
                                            </span>
                                        )}
                                    </div>

                                    {/* Info */}
                                    <div className="flex-1 ml-4">
                                        <p className="text-cs-dark font-extrabold text-sm tracking-tight">Load #{load.id}</p>
                                        <div className="flex items-center gap-1.5">
                                            <div className={`w-1.5 h-1.5 rounded-full ${load.status_id < 30 ? 'bg-cs-primary' : 'bg-cs-success'}`} />
                                            <p className="text-cs-muted text-[11px] font-bold uppercase tracking-tight">
                                                {load.status.name}
                                            </p>
                                        </div>
                                    </div>

                                    {/* Arrow */}
                                    <div className="w-8 h-8 rounded-full bg-cs-bg-alt flex items-center justify-center text-cs-muted">
                                        <FaChevronRight size={12} />
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="py-20 flex flex-col items-center justify-center text-center px-10">
                            <div className="w-20 h-20 bg-cs-bg rounded-full flex items-center justify-center text-cs-border mb-4">
                                <FaHistory size={30} />
                            </div>
                            <p className="text-cs-dark font-bold text-sm">No active requests</p>
                            <p className="text-cs-muted text-xs mt-1">When you are assigned a new load, it will appear here.</p>
                        </div>
                    )}
                </section>

                {/* Optional Footer/Action Tip */}
                <div className="mt-4 p-4 rounded-2xl bg-cs-primary/5 border border-cs-primary/10">
                    <p className="text-[10px] text-cs-primary-dark font-medium leading-relaxed">
                        <b>Pro Tip:</b> Make sure your GPS is enabled before starting a journey to ensure automatic arrival detection.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default ServiceRequestNew;